/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.unidades': 'Unidades',
  'unidades.agregarUnidades': 'Crear Unidades',
  'unidades.modificarUnidades': 'Editar Unidades',
  'unidades.unidadId': 'Unidad Id',
  'unidades.empresaId': 'Empresa Id',
  'unidades.tipoUnidadId': 'Tipo Unidad',
  'unidades.descripcionUnidad': 'Descripción Unidad',
  'unidades.descripcionTipoUnidad': ' Descripción  tipo unidad',
  'unidades.abreviatura': 'Abreviatura',
  'unidades.factor': 'Factor conversión',
  'unidades.estado': 'Estado',
  'unidades.VerUnidad': 'Ver Unidades',
  'unidades.TipoUnidadInactivo':'Registro de tipo unidad está inactivo, seleccione uno nuevo.',
};
